import GenericReportMobile from '../_partials/GenericReportMobile';
import { useTranslation } from 'react-i18next';
import TopSellingProductsTableRowHeadingMobile from './TopSellingProductsTableRowHeadingMobile';
import { formatDollars } from '@wix/da-shared-react/pkg/utils/formatting';

const PRO_ONLY_DISPLAY_LIMIT = 3;
const INITIAL_VISIBLE_COUNT = 5;

export default function TopSellingProductsMobile() {
  const { t } = useTranslation();

  const columns = [
    {
      key: 'totalSales',
      label: t('studio.reports.common.table.header.totalSales'),
    },
    {
      key: 'salesVolume',
      label: t('studio.reports.common.table.header.salesVolume'),
      format: formatDollars,
    },
  ];

  return (
    <GenericReportMobile
      reportType="topSellingProducts"
      headingKey="studio.reports.section.topSellingProducts.title"
      descriptionKey="studio.reports.section.topSellingProducts.description"
      descriptionTranslationOptions={{
        postProcess: ['reactPostprocessor'],
        learnMoreLink: (
          <a
            className="text-link-level-2-tertiary"
            href={t(
              'studio.reports.section.topSellingProducts.description.learnMoreLink.url'
            )}
          >
            {t(
              'studio.reports.section.topSellingProducts.description.learnMoreLink.text'
            )}
          </a>
        ),
      }}
      columns={columns}
      RowHeading={TopSellingProductsTableRowHeadingMobile}
      proOnlydisplayLimit={PRO_ONLY_DISPLAY_LIMIT}
      initialVisibleCount={INITIAL_VISIBLE_COUNT}
    />
  );
}
